import { useNavigate } from 'react-router-dom';
import { useCreateTVGuide, useTranslation } from '@/hooks';
import { CreateTVGuideRequest } from '@/types/model';
import TVGuideForm from '@/components/forms/TVGuideForm';
import toast from 'react-hot-toast';
import TVChannelsLayout from '@/pages/content/TVChannelsLayout.tsx';

const CreateTVGuide = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const createTVGuideMutation = useCreateTVGuide();

  const handleSuccess = async (data: CreateTVGuideRequest) => {
    try {
      await createTVGuideMutation.mutateAsync(data);
      toast.success(t.tvGuide.messages.created);
      navigate('/content/tv-channels/tv-guide');
    } catch (error) {
      toast.error(error instanceof Error ? error.message : t.errors.unexpectedError);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/content/tv-channels/tv-guide');
  };

  return (
    <TVChannelsLayout>
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <TVGuideForm
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            isSubmitting={createTVGuideMutation.isPending}
          />
        </div>
      </div>
    </TVChannelsLayout>
  );
};

export default CreateTVGuide;
